import type { FunctionComponent } from "react";
import { Button, Loader } from "@kanda-libs/ks-design-library";
import useInsuranceDocumentButonProps from "components/company/CompanyLayout/CompanyDetails/Company/InsuranceDocument/useInsuranceDocumentButtonProps";

export interface InsuranceDocumentProps {}

const InsuranceDocument: FunctionComponent<InsuranceDocumentProps> =
  function ({}) {
    const { onClick, isSubmitting } = useInsuranceDocumentButonProps();

    return (
      <>
        <Button.Text
          id="download-insurance-document"
          label="Download insurance document"
          size={40}
          onClick={onClick}
          disabled={isSubmitting}
          className="mb-4"
        />
        <Loader isLoading={isSubmitting} />
      </>
    );
  };

export default InsuranceDocument;
